import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { VocabHelperService } from '../../../services/vocab-helper/vocab-helper.service';
import { attachmentLabels } from '../../../order-info/order-info.model';
import { LoaderService } from '../../../services/loader-service/loader.service';
import { DoumentUploadService } from '../../../services/doucument-upload-service/doument-upload.service';
import _ from 'lodash';
import { SelectModule } from 'primeng/select';
import { LoaderComponent } from '../../../loader/loader.component';
import { DocumentDeleteService } from '../../../services/document-delete-service/document-delete.service';
import { ModalComponent } from '../../modal/modal.component';
import { AttachmentProcessorService } from '../../../orders/place-order/attachment.processor.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-attachments',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FileUploadModule,
    PanelModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    SelectModule,
    LoaderComponent,
    ModalComponent
  ],
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent implements OnInit {
  attachmentLabels = attachmentLabels;
  @Input() attachments: any[] = [];
  @Input() headerStyleClass: string = 'panel-skew-heading';
  @Input() editOrder = false;
  @Input() attachmentForm!: any;
  @Input() parentId: string = '';
  @Input() instructionText: string = '';
  @Input() instructionText2: string = '';
  @Input() documentType: string = 'OrderDocumentCode';
  @Input() headerText: string = 'Attachments';
  @Input() headerHidden: boolean = false;
  fileSizeError = false;
  showDescription = false;
  isBetween576And992 = false;
  isUploadDisabled = true;
  selectedFile: File | null = null;
  maxFileSize: number = 104857600;
  fileUpload: any;
  recordFile: any;
  showFileDeleteModal: boolean = false;
  itemFileToDelete: number | null = null;
  fileUploadVisible: boolean = false;
  fileName: string = '';

  constructor(private fb: FormBuilder, private readonly vocabHelperService: VocabHelperService, private readonly loaderService: LoaderService, private readonly documentUploadSercive: DoumentUploadService,
    private readonly documentDeleteService: DocumentDeleteService, private attachmentsProcessorService: AttachmentProcessorService, private messageService: MessageService) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.fileUploadVisible = true;
    });
    this.checkViewport();
    window.addEventListener('resize', this.checkViewport.bind(this));

    this.vocabHelperService.getVocabData([this.documentType]).subscribe({
      next: (data) => {
        if (data) {
          const attachmentLabelData = data.find(d => d.vocabularyName === this.documentType);
          if (attachmentLabelData) {
            this.attachmentLabels = attachmentLabelData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
            this.attachmentLabels = this.getSortedDocumentTitle(this.attachmentLabels);
          }
        }
      }
    })
  }

  
checkViewport() {
    const width = window.innerWidth;
    this.isBetween576And992 = width >= 576 && width < 992;
  }

  getSortedDocumentTitle(list: any): { name: string, value: string }[] {
    return list.sort((a: any, b: any) => {
    if (a.name.toLowerCase() === "other") return 1;
    if (b.name.toLowerCase() === "other") return -1;
    return 0;
});
  }

  isError(controlId: any, control?: any) {
    let formControl = this.attachmentForm.get(controlId);
    if (!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  isFileUploaded(): boolean {
    const control = this.attachmentForm.get('orderInfoAttachmentLabel');
    const isRequired = control?.hasValidator(Validators.required) ?? false;
    return isRequired;
  }


  onFileSelect(event: any, fileUpload: any) {
    this.fileName = event.files[0]?.name || '';
    if (event.files[0] && event.files[0].size > this.maxFileSize) {
      this.fileSizeError = true;
      this.isUploadButtonDisabled();
      return;
    } else
      this.fileSizeError = false;

    this.fileUpload = fileUpload;
    this.recordFile = event.files[0];
    this.attachmentForm.get('orderInfoAttachmentLabel')?.setValidators(Validators.required);
    this.attachmentForm.get('orderInfoAttachmentLabel')?.updateValueAndValidity();
    this.isUploadButtonDisabled();
    this.isFileUploaded();
  }

  isUploadButtonDisabled() {
    if (!this.fileSizeError && this.fileUpload && this.attachmentForm.get('orderInfoAttachmentLabel')?.value) {
      if (this.attachmentForm.get('orderInfoAttachmentLabel')?.value.value === 'OTH' && !this.attachmentForm.get('orderInfoAttachmentExplanation')?.value) {
        this.isUploadDisabled = true;
        return;
      }
      this.isUploadDisabled = false;
    } else {
      this.isUploadDisabled = true;
    }
  }

  onLabelChange(event: any) {
    this.showDescription = ['other-request','oth','other-order'].includes(event?.value?.value?.toLowerCase());
    this.showDescription === true ? this.setAttachmentValidation() : this.clearAttachmentValidation();
    this.isUploadButtonDisabled();
  }

  setAttachmentValidation() {
    this.attachmentForm.get('orderInfoAttachmentExplanation')?.setValidators(Validators.required);
    this.attachmentForm.get('orderInfoAttachmentExplanation')?.updateValueAndValidity();
  }

  clearAttachmentValidation() {
    this.attachmentForm.get('orderInfoAttachmentLabel')?.clearValidators();
    this.attachmentForm.get('orderInfoAttachmentExplanation')?.clearValidators();
    this.attachmentForm.get('orderInfoAttachmentLabel')?.updateValueAndValidity();
    this.attachmentForm.get('orderInfoAttachmentExplanation')?.updateValueAndValidity();
  }

  onDescriptionChange() {
    this.isUploadButtonDisabled();
  }

  uploadFile(event: any) {
    this.loaderService.show(); // Set isLoading to true before starting the upload
    this.documentUploadSercive.uploadDocument(this.recordFile, this.fileName).subscribe(response => {
      this.loaderService.hide();
      if (response) {
    if (this.recordFile && this.attachmentForm.get('orderInfoAttachmentLabel')?.valid) {
      let labelText = '';
      if ( ['other-request','oth','other-order'].includes(_.toLower(this.attachmentForm.get('orderInfoAttachmentLabel')?.value?.value))) {
        labelText = this.attachmentForm.get('orderInfoAttachmentLabel')?.value.name + ' - ' + this.attachmentForm.get('orderInfoAttachmentExplanation')?.value;
      }
      else {
        labelText = this.attachmentForm.get('orderInfoAttachmentLabel')?.value.value;
      }
      const newAttachment = {
        label: this.attachmentForm.get('orderInfoAttachmentLabel')?.value?.value,
        filename: this.recordFile?.name,
        fileId: Date.now(), // Unique ID for the file
        description: labelText,
        storageId: response?.id,
        storageProviderId: response?.providerId,
        type: this.recordFile?.type,
        size: this.recordFile?.size,
        sizeText: _.toString((this.recordFile?.size > 0 ? _.round(this.recordFile?.size / 1024, 2) : 0)) + ' KB',
        isNew: true
      };
      this.attachments.push(newAttachment);

      if(this.parentId === 'record') {
      let requestDocuments: any[] = this.attachmentsProcessorService.getRequestDocuments();
      if (requestDocuments.length === 0) {
        requestDocuments.push({ requestNumber: 1, documentList: this.attachments });
        this.attachmentsProcessorService.setRequestDocuments(requestDocuments);
      }
      }
      this.attachmentForm.get('orderInfoAttachmentFile')?.setValue(this.attachments);
      this.cancelUpload(this.fileUpload);
    }
     }
    }, error => {
      this.loaderService.hide();
      if (error.includes(415)) {
        this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'Upload Failed: File blocked due to security restrictions. Please use a safe file type and try again.', sticky: true });  
      } else {
        this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'Upload Failed: Please try again later.', sticky: true });
      }
      console.error('File upload failed:', error);
    });
    this.clearAttachmentValidation();
  }

  getLabelDescription(label: any){
    return this.attachmentLabels.find(x=> x.value == label)?.name || label;
  }


  cancelUpload(fileupload: any) {
    fileupload.clear();
    fileupload.msgs = [];
    this.fileSizeError = false;
    this.showDescription = false;
    this.fileUpload = null;
    const labelControl = this.attachmentForm.get('orderInfoAttachmentLabel');
    const explanationControl = this.attachmentForm.get('orderInfoAttachmentExplanation');
    labelControl?.clearValidators();
    explanationControl?.clearValidators();
    labelControl?.reset();
    explanationControl?.reset();
    labelControl?.markAsPristine();
    labelControl?.markAsUntouched();
    explanationControl?.markAsPristine();
    explanationControl?.markAsUntouched();
    this.isFileUploaded();
    this.isUploadButtonDisabled();
  }

  showFileDeletionModal(fileId: number): void {
    this.showFileDeleteModal = true;
    this.itemFileToDelete = fileId;
  }

  downloadFile(fileId: string): void {
    // this.fileDownloaded.emit(fileId);
  }

  confirmFileDeletion() {
    if (this.itemFileToDelete != null) {
      this.deleteFile(this.itemFileToDelete);
      this.itemFileToDelete = null;
      this.showFileDeleteModal = false;
    }
  }

  deleteFile(fileId: number) {
    this.loaderService.show();
    // Find the index of the file with the given fileId
    const index = this.attachments.findIndex(attachment => attachment.fileId === fileId);
    this.documentDeleteService.deleteDocument('standard', this.attachments[index].storageId).subscribe(res => {
      this.loaderService.hide();
      if (res === null) {
        if (index !== -1) {
          this.attachments.splice(index, 1);
          this.messageService.add({
            severity: 'success',
            summary: 'SUCCESS',
            detail: `File successfully deleted.`,
            life: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      }
    }, error => {
      this.messageService.add({
        severity: 'error',
        summary: 'ERROR',
        detail: `Failed to delete the file.`,
        life: 3000,
      });
      this.loaderService.hide();
    });

    this.showDescription = false;
    this.attachmentForm.get('orderInfoAttachmentLabel')?.reset();
  }
}

